<script setup>
import { trans } from '@elements/translation';
import { EVENT_SLIDERS } from '../../general/event-constants';

const emit = defineEmits([ 'openModal' ]);

const emitClick = () => {
  emit('openModal', {
    title: trans('gestion.invoices.slider.infos_invoices.title'),
    name: EVENT_SLIDERS.CREATE_STRIPE_INVOICE,
  });
};
</script>

<template>
  <li @click="emitClick">
    <span>{{ trans('gestion.subscription.create_invoice') }}</span>
  </li>
</template>
